import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer3 extends Component {
    render() {
        return (
                <footer className="site-footer map-footer text-white footer-gradient ">
					<div className="footer-top">
						<div className="container-fluid">
							<div className="row" >
								<div className="col-xl-9 col-md-6 col-lg-6 p-a0">
								 <iframe className="footer-map" title="Standort Rumours Media – Braderuper Weg 3, 25999 Kampen" src="https://maps.google.com/maps?q=Braderuper%20Weg%203%2C%2025999%20Kampen&z=14&output=embed"></iframe>
								</div>
								<div className="col-xl-3 col-md-12 col-lg-12">
									<div className="row footer-content-link">
										<div className="col-lg-12 col-md-12 col-sm-12">
											<div className="widget widget_services border-0">
												<h5 className="m-b15 text-white">Wichtige Links</h5>
												<ul>
													<li><Link to={"/contact"}>Kontakt</Link></li>
													<li><Link to={"/impressum"}>Impressum</Link></li>
														<li><Link to={"/datenschutz"}>Datenschutz</Link></li>
												</ul>
											</div>
										</div>
									</div>
									<div className="footer-bottom text-left row">
										<div className="col-md-12 col-sm-12 text-left p-lr30"> 
											<span>Copyright &copy; {new Date().getFullYear()} Maximilian Müller</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</footer>
				
        );
    }
}

export default Footer3;